import React from "react";
import { Box, Card, Chip, Stack, Typography } from "@mui/material";
import { enterpriseTokens } from "styles/theme";

const SchedulePanel = ({ title, subtitle, eyebrow, action, legend, children, sx = {}, bodySx = {} }) => {
    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: "3px",
                border: `1px solid ${enterpriseTokens.lineSoft}`,
                backgroundColor: "#FFFFFF",
                overflow: "hidden",
                width: "100%",
                boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
                ...sx,
            }}
        >
            <Box
                sx={{
                    px: 1.5,
                    py: 1.25,
                    borderBottom: `1px solid ${enterpriseTokens.lineSoft}`,
                    backgroundColor: "#FBFCFE",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", md: "center" },
                    gap: 2,
                    flexDirection: { xs: "column", md: "row" },
                }}
            >
                <Box>
                    {eyebrow && (
                        <Chip
                            label={eyebrow}
                            size="small"
                            sx={{
                                mb: 0.5,
                                height: 19,
                                borderRadius: "999px",
                                bgcolor: enterpriseTokens.primarySoft,
                                color: enterpriseTokens.primaryDark,
                                fontWeight: 600,
                                fontSize: "9px",
                                textTransform: "uppercase",
                            }}
                        />
                    )}
                    <Typography
                        sx={{
                            fontFamily: "Inter, Outfit, sans-serif",
                            fontSize: "12px",
                            lineHeight: "20px",
                            fontWeight: 600,
                            color: enterpriseTokens.navy,
                        }}
                    >
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography
                            sx={{
                                mt: 0.25,
                                fontFamily: "Inter, Outfit, sans-serif",
                                fontSize: "11px",
                                lineHeight: "16px",
                                fontWeight: 500,
                                color: enterpriseTokens.muted,
                            }}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                {(action || legend) && (
                    <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
                        {legend}
                        {action}
                    </Stack>
                )}
            </Box>
            <Box sx={{ p: 0, ...bodySx }}>{children}</Box>
        </Card>
    );
};

export default SchedulePanel;
